import { jsx } from 'react/jsx-runtime';
import 'react';
import 'styled-components';
import 'luxon';
import 'lodash';
import '../../../charts/ChartKpis/ChartKpi.js';
import '../../../charts/ChartJS.js';
import '../../../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../../icons/ActivityIcon.js';
import '../../../icons/ArrowDownIcon.js';
import '../../../icons/ArrowDownRightCircleIcon.js';
import '../../../icons/ArrowLeftAlignIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import '../../../icons/ArrowRightAlignIcon.js';
import '../../../icons/ArrowRightIcon.js';
import '../../../icons/ArrowSwitchIcon.js';
import '../../../icons/ArrowUpIcon.js';
import '../../../icons/ArrowUpRightCircleIcon.js';
import '../../../icons/ArrowsAngleExpandIcon.js';
import '../../../icons/BankIcon.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/CrossIcon.js';
import '../../../icons/DaiIcon.js';
import '../../../icons/DangerIcon.js';
import '../../../icons/DownSortIcon.js';
import '../../../icons/ExclamationTriangleIcon.js';
import '../../../icons/ExpandKpiIcon.js';
import '../../../icons/EyeIcon.js';
import '../../../icons/EyeSlashIcon.js';
import '../../../icons/Grid1x2Icon.js';
import '../../../icons/InfoCircleIcon.js';
import '../../../icons/ListIcon.js';
import '../../../icons/LockIcon.js';
import '../../../icons/MediumIcon.js';
import '../../../icons/MoonIcon.js';
import '../../../icons/PiggyBankIcon.js';
import '../../../icons/QuestionMarkCircleIcon.js';
import '../../../icons/ShieldIcon.js';
import '../../../icons/SunIcon.js';
import '../../../icons/UpSortIcon.js';
import '../../../icons/XIcon.js';
import '../../../icons/InfinityIcon.js';
import '../../../icons/ArrowUpRightBoxIcon.js';
import '../../../pictograms/EthPictogram.js';
import '../../../pictograms/EtherScanPictogram.js';
import '../../../pictograms/DebankPictogram.js';
import '../../../pictograms/ZapperPictogram.js';
import '../../../pictograms/DaiPictogram.js';
import '../../../XRay.js';
import '../../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import ThemedComponentWrapper from '../../../../theme/ThemedComponentWrapper.js';
import 'ethereum-blockies-base64';
import '../../../atoms/layout/Stack/Stack.js';
import '../../../atoms/Table/components/Pagination/Pagination.js';
import '../../../atoms/Table/Table.js';
import '../../../atoms/ToggleSwitch.js';
import '@floating-ui/react';
import '../../../atoms/Tooltip/components/TooltipContext.js';
import '../../CurrencyValue/components/Value.js';
import TrendComponent from './TrendComponent.js';
import '../KpiCard.js';
import PercentageValue from '../../PercentageValue.js';
import '../../Tabs/Tabs.js';
import '../../TrendValue.js';
import '../../Modal/Modal.js';

function KpiCardValueTrend({ trendChange, trendChangePercentage, percentage = false, options, ...rest }) {
    if (!trendChange) {
        return;
    }
    return (jsx(ThemedComponentWrapper, { ...rest, name: "kpiCardValueTrend", children: percentage === true ? (jsx(PercentageValue, { value: trendChange, options: {
                trend: true,
                formatPercentageOptions: {
                    maximumFractionDigits: 2
                },
                tooltip: false,
                ...options?.percentageValueOptions
            }, variant: options?.variants?.percentageValue })) : (jsx(TrendComponent, { trendChange: trendChange, trendChangePercentage: trendChangePercentage, options: options })) }));
}

export { KpiCardValueTrend as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
